import client_core from "@/services/clients/client_core";

const CodecService = {

    getCodecs(pars) {
        let params = {}
        if ('isActive' in pars)
            params['is_active'] = pars.isActive
        if ('picaServiceId' in pars)
            params['pica_service_id'] = pars.picaServiceId
        return client_core.get('/codecs/v1/codecs/', { params })
    },
}

export default CodecService